module.exports = "<div><%=id%></div>";
